import React from 'react';
import { DatePicker as MuiDatePicker, DatePickerProps } from '@material-ui/pickers';

const DatePicker = React.forwardRef<HTMLDivElement, DatePickerProps>((props: DatePickerProps, ref) => {
  return <MuiDatePicker {...props} />;
});

export default DatePicker;
